import { render } from "./B2CCreateProfileTile.vue?vue&type=template&id=6bdd30cc&ts=true"
import script from "./B2CCreateProfileTile.vue?vue&type=script&lang=ts"
export * from "./B2CCreateProfileTile.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__